<script>
    import { TokenStore } from "$/stores/TokenStore";
</script>

{#if $TokenStore.user}
    <!-- Intercom login user -->
    <!-- NOTE: void ***** || "" is added because without it svelte just prints undefined -->
    {void window.Intercom("boot", {
        api_base: "https://api-iam.intercom.io",
        app_id: "xzk7pqs8",
        email: $TokenStore.user.email,
        user_hash: $TokenStore.intercomToken,
    }) || ""}
{/if}
